import { FundBasketLinkedSip } from "@funds/components/baskets/fund-basket-client";
import { createFileRoute } from "@tanstack/react-router";
import {
  fundBasketLinkedSipsQueryOptions,
  fundBasketQueryOptions,
} from "creso-core/hooks";

export const Route = createFileRoute(
  "/(auth)/_headed/funds/basket/$basket_id/linked-sip"
)({
  loader: async ({ context, params }) => {
    const { queryClient } = context;

    await queryClient.ensureQueryData(fundBasketQueryOptions(params.basket_id));

    await queryClient.ensureQueryData(
      fundBasketLinkedSipsQueryOptions(params.basket_id)
    );
  },
  component: function Component() {
    const { basket_id } = Route.useParams();
    return <FundBasketLinkedSip basketId={basket_id} />;
  },
});
